export { default as SvgSpinner } from './spinner'
export { default as RecipeIcon } from './RecipeIcon'
export { default as DiscoverIcon } from './DiscoverIcon'
export { default as DashboardIcon } from './DashboardIcon'
export { default as ShoppingIcon } from './ShoppingIcon'
export { default as MealPlannerIcon } from './MealPlannerIcon'
export { default as PeopleIcon } from './PeopleIcon'